<template>
  <b-container fluid >
    <b-row>
      <b-col>
        <h1 class="h1">Informe Facturació</h1>
      </b-col>
        <b-col class="col text-right">
            <b-button class="p-2 m-2" variant="outline-success" @click="print">
                <b-icon icon="printer-fill"></b-icon>
                Imprimir
            </b-button>
      </b-col>
    </b-row>

    <div id="printMe">
        <h2>Llistat Factures proper Venciment</h2>
        <b-table 
            small 
            :items="facturas" 
            :fields="fieldsFacturas"
        >
            <template v-slot:cell(numFact)="data">
              {{ data.item.serieIdentifier }}-{{ data.item.numFact }}
            </template>
            <template v-slot:cell(precioBase)="data">
                {{ data.item.precioBase.toFixed(2) }} €
            </template>
            <template v-slot:cell(impuestoIVA)="data">
                {{ data.item.impuestoIVA.toFixed(2) }} €
            </template>
            <template v-slot:cell(totalFactura)="data">
                {{ data.item.totalFactura.toFixed(2) }} €
            </template>
            <template v-slot:cell(isPagada)="data">
                <template v-if="data.item.isPagada">
                <span>&check;</span>
                </template>
            </template>

            <template v-slot:custom-foot="data">
                <b-tr>
                    <b-td><b>TOTALES</b></b-td>
                    <b-td
                        ><b>{{ data.items.length }}</b>
                    </b-td>
                    <b-td></b-td>
                    <b-td></b-td>
                    <b-td>
                        <b>{{ data.items.reduce((a, c) => a + c.precioBase, 0).toFixed(2)}} €</b>
                    </b-td>
                    <b-td>
                        <b>{{ data.items.reduce((a, c) => a + c.impuestoIVA, 0).toFixed(2)}} €</b>
                    </b-td>
                    <b-td>
                        <b>{{ data.items.reduce((a, c) => a + c.totalFactura, 0).toFixed(2)}} €</b>
                    </b-td>
                    <b-td></b-td>
                </b-tr>
            </template>
        </b-table>
    </div>
   </b-container>
</template>

<script>
  import DataAccess from "@/Services/DataAccess.js";
  import moment from "moment";

export default {
    data(){
        return {
            facturas: [],
            fieldsFacturas:
            [
                {
                    key: 'numFact',
                    label: 'Nº Fact',
                    sortable: false
                },
                {
                    key: 'fechaFactura',
                    label: 'Fecha Fact.',
                    sortable: false,
                    sortDirection: 'desc',
                    formatter: (value) => {
                        return moment(value).format('DD/MM/YYYY')
                    }
                },
                {
                    key: 'clienteNombre',
                    label: 'Cliente'
                },
                {
                    key: 'fechaVencimiento',
                    label: 'Fecha Vto.',
                    sortable: false,
                    sortDirection: 'desc',
                    formatter: (value) => {
                        return moment(value).format('DD/MM/YYYY')
                    }
                },           
                {
                    key: 'precioBase',
                    label: 'Base'
                    },
                {
                    key: 'impuestoIVA',
                    label: 'IVA'
                },
                {
                    key: 'totalFactura',
                    label: 'Total Fact'
                },
                {
                    key: 'isPagada',
                    label: 'Cobrada'
                },
            ]
        }
    },
   created() {
      (async () => {
        var url = "/api/InformesFactura";
        await DataAccess.getData(url)
          .then((response) => {
            this.facturas = response.data;
            this.totalRows = this.facturas.length;
            this.loading = false;
          })
          .catch((error) => {
            console.log("ERROR: ", error);
          });
      })();
    },
    methods: {
      getActualMonth() {
        var date = Date();
        return moment(date).add(1, "months").locale("es").format("MMMM");
      },
      print () {
        // Pass the element id here
        this.$htmlToPaper('printMe');
        }
    },
  };
</script>

<style lang="scss" scoped>
</style>